module.exports = new __parcel__URL__("paw-color-icon-2.47f7229a.svg").toString();